module.exports = __webpack_public_path__ + "img/DNADamage-CRC_GSE225857.a7572e07.png";